export default "__VITE_ASSET__f98e71e9__"